import { Box, Typography } from '@mui/material';
import React from 'react';

/**
 * Box qui s'affichera si le tableau ne contient aucune information
 * @param props
 * @constructor
 */
export default function NoData(props: Readonly<{ title: string; content: string }>) {
    // retourne la box avec titre et message personnalisé
    return (
        <Box
            sx={{
                margin: '24px auto',
                maxWidth: '720px',
                padding: '8px 16px',
                textAlign: 'center',
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: '#5f738e',
                    fontWeight: 600,
                    lineHeight: 1.35,
                    marginBottom: '4px',
                }}
            >
                {props.title}
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: '#334155',
                    lineHeight: 1.45,
                }}
            >
                {props.content}
            </Typography>
        </Box>
    );
}
